<div
  class="tier-list-container"
  [class.in-drawer]="isInDrawer()"
  *transloco="let t; prefix: 'components.wager-options'"
>
  @if (themeService.wagerDrawerConfig().hasBalance) {
    <div class="available-balance">
      <div [ngStyle]="bodyStyle | theme">{{ t("available-balance") }} {{ formattedBalance() }}</div>
    </div>
  } @else {
    <div class="no-balance-padding"></div>
  }

  <ng-template #practiceCard>
    <app-practice-card
      [class.practice-row]="practiceRow()"
      [layout]="practiceRow() ? 'row' : 'tile'"
      [title]="t('for-fun')"
      [prize]="t('practice')"
      [buttonLabel]="t('free-to-play')"
      (clickEvent)="onPracticeClick()"
    />
  </ng-template>

  <!-- A section heading: the label between two rules and sparkles where the theme's divider
       tokens turn them on, otherwise a plain left-aligned title. -->
  <ng-template #sectionTitle let-label>
    <div [ngStyle]="titleStyle | theme" class="section-title">
      <span class="section-rule"></span>
      <app-icon
        class="section-ornament"
        icon="sparkle"
        colorCss="--panel-wager-tier-list-title-ornament-fill"
        sizeCss="--icon-small"
      />
      <span class="section-label">{{ label }}</span>
      <app-icon
        class="section-ornament"
        icon="sparkle"
        colorCss="--panel-wager-tier-list-title-ornament-fill"
        sizeCss="--icon-small"
      />
      <span class="section-rule"></span>
    </div>
  </ng-template>

  <div class="prize-tier-list">
    <div class="grid-container" [class.has-free-match]="visibleFreeMatches().length > 0">
      @if (currentTournamentData()(); as tournamentData) {
        @if (showTournamentCard()) {
          <app-tournament-info-card
            class="tournament-card"
            [currentTournamentData]="tournamentData"
            [currentTime]="tick()"
            [isMarbles]="isMarbles()"
            [paymentInFlight]="paymentInFlight()"
            (clickEvent)="onTournamentPlayClick($event)"
            (tutorialRequestedEvent)="onTutorialRequested($event)"
            (leaderboardRequestedEvent)="onLeaderboardRequested($event)"
          />
        }
      }
      @if (soloTiers()().length > 0) {
        <app-solo-card
          class="solo-card"
          [soloTiers]="soloTiers()()"
          [disabled]="paymentInFlight()"
          (clickEvent)="onSoloClick()"
        />
      }
      @if (showTournamentCard() || soloTiers()().length > 0) {
        <ng-container *ngTemplateOutlet="sectionTitle; context: { $implicit: t('head-to-head') }" />
      }
      @if (isPracticeFirst() && !hidePractice()) {
        <ng-container *ngTemplateOutlet="practiceCard" />
      }
      @for (item of tierListItems(); track trackTierListItem(item)) {
        @switch (item.kind) {
          @case ("free") {
            <app-free-match-card
              [grant]="item.grant"
              [now]="tick()"
              [waitingOpponents]="waitingOpponentsStandard()()"
              [paymentInFlight]="paymentInFlight()"
              (clickEvent)="onFreeMatchClick($event)"
            />
          }
          @case ("paid") {
            <app-wager-card
              [tier]="item.tier"
              [allTiers]="allTiers()()"
              [title]="t('title')"
              (clickEvent)="onWagerClick($event)"
              (celebrationCompleteEvent)="onUnlockCelebrationComplete()"
              (celebrationClearedEvent)="onCelebrationCleared()"
              [unlockCelebrationActive]="unlockCelebrationActive"
              [waitingOpponentsStandard]="waitingOpponentsStandard()"
              [userBalance]="userBalance()"
              [paymentInFlight]="paymentInFlight()"
            />
          }
        }
      }
      @if (!isPracticeFirst() && !hidePractice()) {
        <ng-container *ngTemplateOutlet="practiceCard" />
      }
      @if (canShowLocal()) {
        <app-practice-card
          [title]="t('for-testing')"
          [prize]="t('local')"
          [buttonLabel]="t('free-to-play')"
          (clickEvent)="onLocalClick()"
        />
      }
    </div>
    @if (themeService.hasWaitingOpponents()) {
      <div class="player-waiting-opponent">
        <app-icon
          icon="player-waiting"
          colorCss="--panel-wager-tier-list-player-waiting-fill"
          sizeCss="--icon-medium"
        />
        <div [ngStyle]="playerWaitingStyle | theme">
          {{ t("opponent-is-ready") }}
        </div>
      </div>
    }
  </div>
</div>
